import { Components } from '@mui/material';

export const getMuiStep = (): Components['MuiStep'] => ({
  styleOverrides: {
    root: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});
